import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBar = () => {
  const integrations = [
    { name: "QuickBooks", icon: "Database" },
    { name: "CSV Export", icon: "FileText" },
    { name: "Excel", icon: "Sheet" },
    { name: "Xero", icon: "BarChart3" }
  ];

  const metrics = [
    {
      value: "10,000+",
      label: "Transactions Daily",
      icon: "TrendingUp",
      color: "text-blue-400"
    },
    {
      value: "99.7%",
      label: "Accuracy Rate",
      icon: "Target",
      color: "text-green-400"
    },
    {
      value: "15+",
      label: "Hours Saved Weekly",
      icon: "Clock",
      color: "text-purple-400"
    },
    {
      value: "94%",
      label: "Error Reduction",
      icon: "Shield",
      color: "text-amber-400"
    }
  ];

  return (
    <section className="py-16 bg-card/30 backdrop-blur-sm border-y border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Integrations removed for launch */}

        {/* Metrics */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {metrics?.map((metric, index) => (
            <div
              key={index}
              className="text-center p-6 bg-background/50 rounded-xl border border-border hover:border-primary/20 transition-all duration-200 trust-signal"
            >
              <div className={`inline-flex items-center justify-center w-12 h-12 rounded-lg bg-card/50 mb-4 ${metric?.color}`}>
                <Icon name={metric?.icon} size={24} />
              </div>
              <div className="space-y-1">
                <div className="text-2xl font-bold text-foreground">
                  {metric?.value}
                </div>
                <div className="text-sm text-muted-foreground">
                  {metric?.label}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Security Badge */}
        <div className="flex items-center justify-center mt-12">
          <a
            href="https://registry.blockmarktech.com/certificates/7150f0f9-eacc-4a5a-a484-c00107793ce0/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-4 px-6 py-3 bg-background/50 rounded-full border border-border hover:border-primary/30 transition-all duration-200"
          >
            {/* Cropped iframe to hide BM branding - scaled down 50% */}
            <div style={{ width: '48px', height: '48px', overflow: 'hidden', flexShrink: 0 }}>
              <iframe
                src="https://registry.blockmarktech.com/certificates/7150f0f9-eacc-4a5a-a484-c00107793ce0/widget/?tooltip_position=bottom&theme=transparent"
                style={{
                  border: 'none',
                  height: '132px',
                  width: '132px',
                  transform: 'scale(0.5)',
                  transformOrigin: 'top left',
                  pointerEvents: 'none'
                }}
                title="Cyber Essentials Certified"
              />
            </div>
            <span className="text-sm font-medium text-foreground">
              Cyber Essentials certified
            </span>
            <div className="w-1 h-1 bg-muted-foreground rounded-full"></div>
            <span className="text-sm text-muted-foreground">
              UK government-backed security standard
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;